import { useEffect } from 'react';
import { wait } from '../utils';

export const useAsyncWait = (
  setInStatus: (newStatus: boolean) => void,
  delay = 300
): void => {
  useEffect(() => {
    let isMounted = true;
    wait(delay).then(() => isMounted && setInStatus(true));
    return () => {
      isMounted = false;
    };
  }, [delay, setInStatus]);
};
